// Redux
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Interfaces
import { DealData } from '@interfaces/deal'

interface UserDetails {
  jwt: string
  email: string
}

interface UserState {
  userDetails: UserDetails
  flightDeals: DealData[]
  loadingFlightDeals: boolean
  loadingUserDetails: boolean
}

const initialState: UserState = {
  userDetails: {
    jwt: '',
    email: ''
  },
  flightDeals: [],
  loadingFlightDeals: true,
  loadingUserDetails: true
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserFlightDeals: (state, action: PayloadAction<DealData[]>) => ({
      ...state,
      flightDeals: action.payload,
      loadingFlightDeals: false
    }),
    setUserDetails: (state, action: PayloadAction<UserDetails>) => ({
      ...state,
      userDetails: action.payload,
      loadingUserDetails: false
    }),
  }
})

export const {
  setUserFlightDeals,
  setUserDetails
} = userSlice.actions
export default userSlice.reducer
